import {computed, inject, Inject, Injectable} from '@angular/core';
import {exhaustMap, tap} from 'rxjs';
import {AUTH_CONFIG} from 'src/app/config/auth.config';
import {JWT_CONFIG} from 'src/app/config/jwt.config';
import {SignalStore} from 'src/app/shared/functions/store.functions';
import {decodeJwt} from 'src/app/shared/functions/encode-decode.functions';
import {ApiService} from './api.service';
import {CookieService} from './cookie.service';
import {AuthResponse} from '../models/auth.model';
import {IJWTDecoded, JWTschema, JWTState} from '../models/jwt.model';
import {createEffect} from 'src/app/shared/functions/create-effect.functions';
import { environment } from 'src/environments/environment';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  readonly token = this.jwtStore.selectKey('token');
  readonly decodedToken = this.jwtStore.selectKey('decodedToken');
  readonly refreshInterval = this.jwtStore.selectKey('refreshInterval');
  readonly isValidToken = computed(() => (this.decodedToken().exp > this.decodedToken().iat) && (this.decodedToken().exp > (Math.floor(Date.now() / 1000))));
  refresh = createEffect((_) => _.pipe(
    exhaustMap(() => {
      return this.keycloakService.updateToken()
    })
  ));
  private refreshTokenInterval = computed(() => (((this.decodedToken()?.exp - this.decodedToken().iat) * 1000) - (AUTH_CONFIG.refreshTokenSecondsAhead * 1000)))

  constructor(
    @Inject('jwt-store') private readonly jwtStore = inject(SignalStore<JWTState>),
    private cookieService: CookieService,
    private apiService: ApiService,
    private keycloakService:KeycloakService
  ) {
    if (this.cookieService.check(JWT_CONFIG.jwtCookieName)) {
      this.set(this.cookieService.get(JWT_CONFIG.jwtCookieName));
    }
  }

  public async set(jwtToken: string) {
    this.jwtStore.setKey<'token'>('token', jwtToken);
     var decodedToken = decodeJwt<IJWTDecoded>(jwtToken, JWTschema)
      this.jwtStore.setKey('decodedToken', decodedToken);
      if (this.isValidToken()) {
        this.apiService.setHeader('Authorization', `Bearer ${jwtToken}`)

        this.cookieService.set(JWT_CONFIG.jwtCookieName, jwtToken);
        clearInterval(this.refreshInterval());
        this.jwtStore.setKey('refreshInterval', setInterval(() => {
          this.refresh();
        }, this.refreshTokenInterval()));
      } else {
        this.unset();
      }
    
  }

  public unset() {
    this.jwtStore.setKey('decodedToken', {
      iat: 0,
      exp: 0,
      userId: null
    });
    this.jwtStore.setKey<'token'>('token', '');
    this.cookieService.delete(JWT_CONFIG.jwtCookieName);
    this.apiService.setHeader('Authorization', undefined);
    if (this.refreshInterval()) {
      clearInterval(this.refreshInterval());
    }
   // this.keycloakService.logout(environment.keycloak.redirectUrl)
  }
}
